import { ReactElement } from 'react';
import { Option, OrderingConfiguration } from 'ui-builder';

export enum GridLayoutTheme {
  LIGHT = 'light',
  STANDARD = 'standard',
  TINY = 'tiny',
}

export interface DynamicColumnsService {
  getValue: () => number[],
  setValue: (value: number[]) => Promise<void>,
  getOptionsFunc: () => Promise<Option<number>[]>,
  getLabel: (value: number) => string,
  getCell: (value: | number) => ReactElement,
  getSortKey: (value: number) => string | undefined,
  getTitle: () => string,
  isUpdateAllowed: () => boolean,
}

export interface GridLayoutProps {
  children: ReactElement | (ReactElement | boolean)[];
  weights?: number[];
  theme?: GridLayoutTheme,
  noDataMessage?: ReactElement | string,
  title?: string | ReactElement,
  dynamicColumns?: DynamicColumnsService,
  className?: string,
}

export interface GridLayoutWithSortProps<T = { id: number, [key: string]: any }> extends GridLayoutProps {
  orderingConfiguration: OrderingConfiguration<T>;
}

